export default __webpack_public_path__ + "static/media/allRecipes.5849b197.png";